module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_2000_Active@1x-b29099260f883aa4b4f4ccd8491810a7.png";